import type { PrivacyNotice, PrivacyNoticeAudience } from './types';
import { PRIVACY_NOTICE_STUDENTS } from './privacy-notice-students';
import { PRIVACY_NOTICE_TEACHERS } from './privacy-notice-teachers';

export type { PrivacyNotice, PrivacyNoticeAudience, PrivacyNoticeBlock } from './types';
export { PRIVACY_NOTICE_STUDENTS, PRIVACY_NOTICE_TEACHERS };

export const PRIVACY_NOTICES: Record<PrivacyNoticeAudience, PrivacyNotice> = {
  student: PRIVACY_NOTICE_STUDENTS,
  teacher: PRIVACY_NOTICE_TEACHERS,
};
